import React, { Component } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';

class EditorLinkDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  handleClickOutside() {
    this.setState({ focused: false });
  }


  render() {
    const { contentState, entityKey, children } = this.props;
    const { url } = contentState.getEntity(entityKey).getData();
    const { focused } = this.state;

    return (
      <span
        onClick={() => this.setState({ focused: true })}
        style={{ position: 'relative' }}
      >
        <a
          href={url}
          target="_blank"
          rel="noreferrer noopener"
          style={{
            color: '#3b5998',
            textDecoration: 'underline',
          }}
        >
          {children}
        </a>
        {focused && <div style={{ position: 'absolute', display: 'block', left: '0' }}>
          {<div
            className="entry-editor-link-display clearfix"
            contentEditable={false}
          >
            <a href={url} target="_blank" rel="noreferrer noopener">{url}</a>
            {/* <div className="entry-editor-link-remove">Remove</div> */}
          </div>}
        </div>}
      </span>
    );
  }
}

EditorLinkDisplay.propTypes = {
  contentState: PropTypes.object,
  entityKey: PropTypes.string,
  children: PropTypes.any,
};


export default onClickOutside(EditorLinkDisplay);



// WEBPACK FOOTER //
// ./src/cms/form/editor/EditorLinkDisplay.js